// Role labels for chat/messages (Polish). Use active_role so switched role shows correctly.
export const ROLE_LABELS = {
  super_admin: 'SuperAdmin',
  branch_admin: 'Administrator placówki',
  teacher: 'Nauczyciel',
  parent: 'Rodzic'
};

export const getRoleLabel = (role) => ROLE_LABELS[role] || role || '';
